import { render, staticRenderFns } from "./SpanStock.vue?vue&type=template&id=54d4278e&"
import script from "./SpanStock.vue?vue&type=script&lang=js&"
export * from "./SpanStock.vue?vue&type=script&lang=js&"
import style0 from "./SpanStock.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports